import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { CompanyDetailsFormDataProviderFactory } from '../factory/CompanyDetailsFormDataProviderFactory';
import { CompanyDetailsFormBaseDataProvider } from '../dataProvider/CompanyDetailsFormBaseDataProvider';
import { CountryData } from '../../../types/country-data';
import { StateData } from '../../../types/state-data';
import { IndustryData } from '../../../types/industry-data';
import { CompanyRoleData } from '../../../types/company-role-data';
import { CompanyTypeData } from '../../../types/company-type-data';
import { CompanyCustomizationData } from '../../../types/company-customization-data';
import { User } from '../../../types/user';
import { LanguageData } from '../../../types/language-data';
import { TimezoneData } from '../../../types/timezone-data';

export class CompanyDetailsFormRepository extends BaseWebComponentRepository {
  public dataProviderFactory: CompanyDetailsFormDataProviderFactory;
  public dataProvider: CompanyDetailsFormBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new CompanyDetailsFormDataProviderFactory(),
    });
  }

  public async getCountries(): Promise<CountryData[]> {
    return this.dataProvider.getCountries();
  }

  public async getStates(): Promise<StateData[]> {
    return this.dataProvider.getStates();
  }

  public async getIndustries(): Promise<IndustryData[]> {
    return this.dataProvider.getIndustries();
  }

  public async getCompanyRoles(): Promise<CompanyRoleData[]> {
    return this.dataProvider.getCompanyRoles();
  }

  public async getDefaultLogoId(): Promise<string> {
    return this.dataProvider.getDefaultLogoId();
  }

  public async getCompanyTypes(): Promise<CompanyTypeData[]> {
    return this.dataProvider.getCompanyTypes();
  }

  public async getCompanyCustomizations(): Promise<CompanyCustomizationData[]> {
    return this.dataProvider.getCompanyCustomizations();
  }

  public async getTimezones(): Promise<TimezoneData[]> {
    return this.dataProvider.getTimezones();
  }

  public async getLanguages(): Promise<LanguageData[]> {
    return this.dataProvider.getLanguages();
  }

  public async getLoggedUser(): Promise<User> {
    return this.dataProvider.getLoggedUser();
  }

  public async getRootVisibilityTree(): Promise<string> {
    return this.dataProvider.getRootVisibilityTree();
  }
}
